import React from 'react'
import { BaseErrorDisplay } from './BaseErrorDisplay'
import infoSvg from '../icons/blankslate-info-icon.svg'

export const FederatedUserInvitationEmailVerifyFailed = () => (
  <BaseErrorDisplay
    title="There is a problem processing your invitation"
    subtitle="FEDERATED USER INVITATION EMAIL VERIFY FAILED"
    description="There was an error verifying your email address as part of the invitation process. Please contact your support."
    imgSrc={infoSvg}
  />
)
